import { EcommerceProduct, ICarDetails, PurchaseOrderProductDto } from '@impact/data';

export function isProductCarDetails(product: unknown): product is ICarDetails {
    return !!(product as ICarDetails).id;
}

export function mapProductToEcommerceVehicle(product: PurchaseOrderProductDto | ICarDetails): EcommerceProduct {
    if (isProductCarDetails(product)) {
        if (!product.id) {
            throw new Error('Product details had no valid id');
        }

        return {
            id: product.id.toString(),
            brand: product.make?.data || '',
            category: 'vehicle',
            name: product.model?.data || '',
            price: product.price?.data?.toFixed(1) || '',
            quantity: 1,
            variant: product.variant?.data || '',
        };
    }

    if (!product.productId) {
        throw new Error('Product purchase had no valid id');
    }

    return {
        id: product.productId.toString(),
        brand: product.make || '',
        category: 'vehicle',
        name: product.model || '',
        price: product.grossPrice?.toFixed(1) || '',
        quantity: 1,
        variant: product.variant || '',
    };
}
